/**
 * Decide whether third-party analytics may initialize for the current URL.
 * Public share tokens are bearer capabilities, so fail closed before loading
 * code that can inspect window.location. No token value is ever read or logged.
 *
 * @param {{pathname?: string, search?: string}} locationLike
 * @returns {boolean}
 */
export const shouldInitializeTagManager = (locationLike = {}) => {
  const pathname = locationLike.pathname || "";
  if (pathname === "/shared" || pathname.startsWith("/shared/")) {
    return false;
  }

  try {
    return !new URLSearchParams(locationLike.search || "").has("share_token");
  } catch {
    // A malformed URL should not weaken capability protection.
    return false;
  }
};
